import { useGetIdentity, useNotify, useUpdate } from "ra-core";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import type { Task } from "../types";
export function TaskQuickStatus({ task }: { task: Task }) {
  const { identity } = useGetIdentity();
  const notify = useNotify();
  const [update, { isPending }] = useUpdate();
  const allowed =
    identity &&
    (identity.administrator ||
      String(task.sales_id) === String(identity.id) ||
      String(task.created_by_sales_id) === String(identity.id));
  const status = task.done_date ? "completed" : (task.status ?? "new");
  return (
    <div
      onClick={(event) => event.stopPropagation()}
      onKeyDown={(event) => event.stopPropagation()}
    >
      <Select
        value={status}
        disabled={!allowed || isPending}
        onValueChange={(next) =>
          update(
            "tasks",
            {
              id: task.id,
              data: {
                status: next,
                done_date:
                  next === "completed" ? new Date().toISOString() : null,
              },
              previousData: task,
            },
            {
              mutationMode: "pessimistic",
              onError: () =>
                notify("Не удалось изменить статус задачи", { type: "error" }),
            },
          )
        }
      >
        <SelectTrigger
          aria-label={`Статус задачи: ${task.text}`}
          className="h-8 w-auto min-w-28 text-xs rounded-full"
        >
          <SelectValue />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="new">Новая</SelectItem>
          <SelectItem value="in_progress">В работе</SelectItem>
          <SelectItem value="completed">Выполнена</SelectItem>
        </SelectContent>
      </Select>
    </div>
  );
}
